import dynamic from 'next/dynamic';
import React from 'react';
const PrivacyPage = dynamic(() => import('@/components/PrivacyPage'), {
  ssr: false,
});

const Privacy = () => {
  return <PrivacyPage />;
};

export default Privacy;
